import { gql } from "gql";

export const LOGOUT = gql(`
  mutation Logout {
    logout
  }  
`);
